import {
  ENABLE_ESHOP_SUBSCRIBE,
  ESHOP_SUBSCRIBE_URL,
} from "@helper/getEnvVariables";
import { useLocation } from "react-router";

export const useSubscribeLink = () => {
  const location = useLocation();
  // Use URLSearchParams to parse the query string
  const queryParams = new URLSearchParams(location.search);
  if (queryParams.get("mobwebview")) {
    return "";
  }
  // EMTM-1621: behind the flag, subscribe CTAs point to the on-domain eShop
  // subscribe page. The CTAs render it in the same tab (no new tab).
  if (ENABLE_ESHOP_SUBSCRIBE && ESHOP_SUBSCRIBE_URL) {
    return ESHOP_SUBSCRIBE_URL;
  }
  return "https://subscribe.sph.com.sg/publications-bh/?utm_campaign=bh_subscription&utm_medium=sph-publication&utm_source=bh&utm_content=subscribelink-header";
};
